import React, {useState} from 'react';
import {
    MarketingQuestionsState,
    QuestionAnswers, SelectStateAndQuestion
} from '../../../../../src/components/CustomersBar/CustomerTab/MarketingTab/MarketingQuestion.state';
import {observer} from 'mobx-react-lite';
import {Select} from '../../../../../src/components/CustomersBar/CustomerTab/MarketingTab/Select/Select';
import {CsvReadItem} from '../../../../../src/AppState/PromotionQuestionsState/PromotionQuestionsState';
import Form from '../../../../../src/components/Form';

interface PropsType {
    answers: QuestionAnswers,
    questions: CsvReadItem[],
    onUpdateRequest: (id: number, data: { marketingQuestionsAnswers: QuestionAnswers }) => void,
    errors: any,
    customerId: number
}

export const QuestionsForm = observer((props: PropsType) => {

    const {answers, questions, onUpdateRequest, errors, customerId} = props;
    const [state] = useState<MarketingQuestionsState>(() => new MarketingQuestionsState(questions, answers));

    return (<QForm
        errors={errors}
        onSubmit={() => {
            const finalAnswers = state.getFinalAnswers();
            onUpdateRequest(customerId, {marketingQuestionsAnswers: finalAnswers});
        }}
    >
        {state.selects.map((select) => <MarketingQuestionsItem data={select} key={select.question.id}/>)}
    </QForm>);

});

class QForm extends Form {

    onSubmit(e: Event) {
        e.preventDefault();
        Form.prototype.onSubmit.call(this, e);
    }

    renderForm() {
        const {errors, children} = this.props;

        return (<div>
            <h2>Marketing</h2>
            {children}
            {this.getBasicError(errors.get && errors.get('program'))}
            <div className='buttons'>
                <button className='btn btn-primary' type='submit'>
                    Update account
                </button>
            </div>
        </div>);

    }
}


interface MarketingQuestionsItemPropsType {
    data: SelectStateAndQuestion
}

const MarketingQuestionsItem = observer((props: MarketingQuestionsItemPropsType) => {

    const select = props.data;
    const {question} = select;

    return (<Select
        name='question-options'
        label={question.name}
        options={select.selectOptions}
        state={select.state}
    />);
});
